// src/pages/message-center/components/ShiftLeaderCommissionCard.jsx
import React from 'react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import { getProgressPercentage, getProgressColorClass } from '../utils/phaseProgressColor';
import PhaseProgressBar from './PhaseProgressBar';
import styles from './ShiftLeaderCommissionCard.module.css';

const ShiftLeaderCommissionCard = ({ leader, isEstimate }) => {
  const { t, formatCurrency, formatDate } = useLocalization();
  const phases = leader.phases || [];

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <h3 className={styles.leaderName}>{leader.userName || '—'}</h3>
      </div>

      <div className={styles.quickGlanceRow}>
        {phases.map((phase) => {
          const percentage = getProgressPercentage(phase.achievedSalesValue, phase.targetValue);
          return (
            <PhaseProgressBar
              key={phase.phaseIndex}
              percentage={percentage}
              colorClass={getProgressColorClass(percentage)}
            />
          );
        })}
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.phaseTable}>
          <thead>
            <tr>
              <th>{t('messageCenterShiftLeaderCommission.phase')}</th>
              <th>{t('messageCenterShiftLeaderCommission.shifts')}</th>
              <th>{t('messageCenterShiftLeaderCommission.orders')}</th>
              <th>{t('messageCenterShiftLeaderCommission.products')}</th>
              <th>{t('messageCenterShiftLeaderCommission.targetValue')}</th>
              <th>{t('callCenterShifts.achievedSalesValue')}</th>
              <th>{t('callCenterCommission.commissionAmount')}</th>
            </tr>
          </thead>
          <tbody>
            {phases.map((phase) => {
              const isAchieved = phase.targetValue != null
                && parseFloat(phase.achievedSalesValue) >= parseFloat(phase.targetValue);
              return (
                <tr key={phase.phaseIndex}>
                  <td>
                    <div className={styles.phaseCell}>
                      <span className={styles.phaseName}>
                        {t('messageCenterShiftLeaderCommission.phase')} {phase.phaseIndex + 1}
                      </span>
                      <span className={styles.dateRange}>
                        {formatDate(phase.phaseDateFrom, { month: 'short', year: undefined })} – {formatDate(phase.phaseDateTo, { month: 'short', year: undefined })}
                      </span>
                    </div>
                  </td>
                  <td>{phase.shiftCount ?? 0}</td>
                  <td>{phase.orderCount ?? 0}</td>
                  <td>{phase.productCount ?? 0}</td>
                  <td>{phase.targetValue != null ? formatCurrency(phase.targetValue) : '—'}</td>
                  <td>
                    <span className={phase.targetValue == null ? undefined : (isAchieved ? styles.achieved : styles.notAchieved)}>
                      {formatCurrency(phase.achievedSalesValue)}
                    </span>
                  </td>
                  <td>{formatCurrency(phase.commissionAmount)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className={styles.cardFooter}>
        <span className={styles.monthTotalLabel}>{t('messageCenterShiftLeaderCommission.monthTotal')}</span>
        <span className={styles.monthTotalValue}>
          {formatCurrency(leader.totalCommissionAmount)}
          {isEstimate && <span className={styles.estimateBadge}>{t('messageCenterCommission.estimate')}</span>}
        </span>
      </div>
    </div>
  );
};

export default ShiftLeaderCommissionCard;
